import logo from 'src/assets/svg/logo_sso.svg';
import calendar from 'src/assets/svg/icon/calendar.svg';
import smsIcon from 'src/assets/svg/icon/sms.svg';
import activityIcon from 'src/assets/svg/icon/activity.svg';
import activityActiveIcon from 'src/assets/svg/icon/activityActive.svg';
import arrowUpActiveIcon from 'src/assets/svg/icon/arrowUpActive.svg';
import arrowRightActiveIcon from 'src/assets/svg/icon/arrowRightActive.svg';
import arrowPageLeftIcon from 'src/assets/svg/icon/arrowPageLeft.svg';
import arrowPageRightIcon from 'src/assets/svg/icon/arrowPageRight.svg';
import caretDownIcon from 'src/assets/svg/icon/caretDown.svg';
import arrowDownIcon from 'src/assets/svg/icon/arrowDown.svg';
import welcomeIcon from 'src/assets/svg/icon/welcome.svg';

import React from 'react';

export type Props = {
  className?: string | undefined;
  width?: number | undefined;
  height?: number | undefined;
  size?: number | undefined;
  color?: string | undefined;
  bgColor?: string | undefined;
  bg?: string | undefined;
  filter?: string | undefined;
  src?: string | undefined;
  onClick?: (
    event: React.MouseEvent<HTMLElement>,
  ) => void | undefined;
};

export const IconLogo = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={logo}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconCalendar = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={calendar}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconSms = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={smsIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconNotification = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#64748B',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M8.55664 17.5C8.70293 17.7533 8.91332 17.9637 9.16668 18.11C9.42003 18.2563 9.70743 18.3333 9.99997 18.3333C10.2925 18.3333 10.5799 18.2563 10.8333 18.11C11.0866 17.9637 11.297 17.7533 11.4433 17.5"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.71821 12.7716C2.60935 12.8909 2.53751 13.0393 2.51143 13.1987C2.48534 13.3581 2.50615 13.5217 2.5713 13.6695C2.63646 13.8173 2.74316 13.9429 2.87843 14.0312C3.01369 14.1195 3.1717 14.1665 3.33321 14.1666H16.6665C16.828 14.1667 16.9861 14.1198 17.1214 14.0317C17.2568 13.9436 17.3636 13.8181 17.429 13.6704C17.4943 13.5227 17.5153 13.3592 17.4894 13.1998C17.4635 13.0404 17.3919 12.8919 17.2832 12.7725C16.1749 11.63 14.9999 10.4158 14.9999 6.66663C14.9999 5.34054 14.4731 4.06877 13.5354 3.13109C12.5977 2.19341 11.326 1.66663 9.99988 1.66663C8.6738 1.66663 7.40203 2.19341 6.46435 3.13109C5.52666 4.06877 4.99988 5.34054 4.99988 6.66663C4.99988 10.4158 3.82405 11.63 2.71821 12.7716Z"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconApp = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#64748B',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M16.6666 3.33337H3.33329C2.41282 3.33337 1.66663 4.07957 1.66663 5.00004V15C1.66663 15.9205 2.41282 16.6667 3.33329 16.6667H16.6666C17.5871 16.6667 18.3333 15.9205 18.3333 15V5.00004C18.3333 4.07957 17.5871 3.33337 16.6666 3.33337Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33337 3.33337V6.66671"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66663 6.66663H18.3333"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3.33337V6.66671"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconAppActive = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#FFFFFF',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#FFFFFF';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M16.6666 3.33337H3.33329C2.41282 3.33337 1.66663 4.07957 1.66663 5.00004V15C1.66663 15.9205 2.41282 16.6667 3.33329 16.6667H16.6666C17.5871 16.6667 18.3333 15.9205 18.3333 15V5.00004C18.3333 4.07957 17.5871 3.33337 16.6666 3.33337Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33337 3.33337V6.66671"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66663 6.66663H18.3333"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3.33337V6.66671"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconFilledDot = ({
  color = '#64748B',
}: Props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="4" fill={color} />
    </svg>
  );
};

export const IconSignIn = ({
  color = '#64748B',
}: Props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.34375 13.2812L10.625 10L7.34375 6.71875" stroke="white" strokeWidth="2" strokeLinecap="round"
            strokeLinejoin="round" />
      <path d="M1.8728 10H10.6228" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.375 3.125H15C15.1658 3.125 15.3247 3.19085 15.4419 3.30806C15.5592 3.42527 15.625 3.58424 15.625 3.75V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H9.375"
        stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
};

export const IconHome = ({
                           className,
                           width = 20,
                           height = 20,
                           size,
                           filter,
                           color = '#64748B',
                           onClick,
                         }: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M16.6704 8.56397L10.42 2.88154C10.3049 2.77694 10.155 2.71899 9.99955 2.71899C9.84406 2.719 9.69415 2.77696 9.57911 2.88157L3.32954 8.56397C3.26511 8.62255 3.21364 8.69394 3.17842 8.77358C3.14319 8.85321 3.125 8.93932 3.125 9.0264V16.2499C3.125 16.4157 3.19085 16.5747 3.30806 16.6919C3.42527 16.8091 3.58424 16.8749 3.75 16.8749H16.25C16.4158 16.8749 16.5747 16.8091 16.6919 16.6919C16.8092 16.5747 16.875 16.4157 16.875 16.2499V9.02642C16.875 8.93934 16.8568 8.85322 16.8216 8.77358C16.7863 8.69395 16.7349 8.62255 16.6704 8.56397Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconHomeActive = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#FFFFFF',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#FFFFFF';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M16.6704 8.56397L10.42 2.88154C10.3049 2.77694 10.155 2.71899 9.99955 2.71899C9.84406 2.719 9.69415 2.77696 9.57911 2.88157L3.32954 8.56397C3.26511 8.62255 3.21364 8.69394 3.17842 8.77358C3.14319 8.85321 3.125 8.93932 3.125 9.0264V16.2499C3.125 16.4157 3.19085 16.5747 3.30806 16.6919C3.42527 16.8091 3.58424 16.8749 3.75 16.8749H16.25C16.4158 16.8749 16.5747 16.8091 16.6919 16.6919C16.8092 16.5747 16.875 16.4157 16.875 16.2499V9.02642C16.875 8.93934 16.8568 8.85322 16.8216 8.77358C16.7863 8.69395 16.7349 8.62255 16.6704 8.56397Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconDocument = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#64748B',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M16.8756 5.625H3.12561C2.78043 5.625 2.50061 5.90482 2.50061 6.25V16.25C2.50061 16.5952 2.78043 16.875 3.12561 16.875H16.8756C17.2208 16.875 17.5006 16.5952 17.5006 16.25V6.25C17.5006 5.90482 17.2208 5.625 16.8756 5.625Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 8.125V4.375C13.125 4.04348 12.9933 3.72554 12.7589 3.49112C12.5245 3.2567 12.2065 3.125 11.875 3.125H8.125C7.79348 3.125 7.47554 3.2567 7.24112 3.49112C7.0067 3.72554 6.875 4.04348 6.875 4.375V8.125"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconDocumentActive = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#FFFFFF',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#FFFFFF';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M16.8756 5.625H3.12561C2.78043 5.625 2.50061 5.90482 2.50061 6.25V16.25C2.50061 16.5952 2.78043 16.875 3.12561 16.875H16.8756C17.2208 16.875 17.5006 16.5952 17.5006 16.25V6.25C17.5006 5.90482 17.2208 5.625 16.8756 5.625Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 8.125V4.375C13.125 4.04348 12.9933 3.72554 12.7589 3.49112C12.5245 3.2567 12.2065 3.125 11.875 3.125H8.125C7.79348 3.125 7.47554 3.2567 7.24112 3.49112C7.0067 3.72554 6.875 4.04348 6.875 4.375V8.125"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconRefresh = ({
  className,
  width = 16,
  height = 16,
  size,
  color = '#6B7280',
  onClick,
}: Props) => {
  const iconSize = size || width || 16;
  const strokeColor = color || '#6B7280';

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
    >
      <path
        d="M8 2.66667V5.33333M8 2.66667C6.52724 2.66667 5.33333 3.86058 5.33333 5.33333M8 2.66667C9.47276 2.66667 10.6667 3.86058 10.6667 5.33333M8 13.3333V10.6667M8 13.3333C9.47276 13.3333 10.6667 12.1394 10.6667 10.6667M8 13.3333C6.52724 13.3333 5.33333 12.1394 5.33333 10.6667M2.66667 8H5.33333M10.6667 8H13.3333"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconPaperclip = ({
  className,
  width = 16,
  height = 16,
  size,
  color = '#6B7280',
  onClick,
}: Props) => {
  const iconSize = size || width || 16;
  const strokeColor = color || '#6B7280';

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
    >
      <path
        d="M11.3333 5.33333L6.66667 10C6.29848 10.3682 5.70152 10.3682 5.33333 10C4.96514 9.63181 4.96514 9.03485 5.33333 8.66667L10 4C10.3682 3.63181 10.9651 3.63181 11.3333 4C11.7015 4.36819 11.7015 4.96514 11.3333 5.33333Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66667 8L4 12.6667C3.63181 13.0349 3.03485 13.0349 2.66667 12.6667C2.29848 12.2985 2.29848 11.7015 2.66667 11.3333L7.33333 6.66667C7.70152 6.29848 8.29848 6.29848 8.66667 6.66667C9.03485 7.03485 9.03485 7.63181 8.66667 8Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconPeople = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#64748B',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M13.3333 17.5V15.8333C13.3333 14.9493 12.9821 14.1014 12.357 13.4763C11.7319 12.8512 10.884 12.5 9.99996 12.5H4.99996C4.1159 12.5 3.26806 12.8512 2.64294 13.4763C2.01782 14.1014 1.66663 14.9493 1.66663 15.8333V17.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3334 2.60669C14.0482 2.792 14.6812 3.20941 15.1331 3.79341C15.585 4.37741 15.8302 5.09493 15.8302 5.83336C15.8302 6.57178 15.585 7.28931 15.1331 7.8733C14.6812 8.4573 14.0482 8.87471 13.3334 9.06002"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3334 17.5001V15.8334C18.3328 15.0948 18.087 14.3774 17.6345 13.7937C17.182 13.2099 16.5485 12.793 15.8334 12.6084"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49996 9.16667C9.34091 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34091 2.5 7.49996 2.5C5.65901 2.5 4.16663 3.99238 4.16663 5.83333C4.16663 7.67428 5.65901 9.16667 7.49996 9.16667Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconPeopleActive = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#FFFFFF',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#FFFFFF';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M13.3333 17.5V15.8333C13.3333 14.9493 12.9821 14.1014 12.357 13.4763C11.7319 12.8512 10.884 12.5 9.99996 12.5H4.99996C4.1159 12.5 3.26806 12.8512 2.64294 13.4763C2.01782 14.1014 1.66663 14.9493 1.66663 15.8333V17.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3334 2.60669C14.0482 2.792 14.6812 3.20941 15.1331 3.79341C15.585 4.37741 15.8302 5.09493 15.8302 5.83336C15.8302 6.57178 15.585 7.28931 15.1331 7.8733C14.6812 8.4573 14.0482 8.87471 13.3334 9.06002"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3334 17.5001V15.8334C18.3328 15.0948 18.087 14.3774 17.6345 13.7937C17.182 13.2099 16.5485 12.793 15.8334 12.6084"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49996 9.16667C9.34091 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34091 2.5 7.49996 2.5C5.65901 2.5 4.16663 3.99238 4.16663 5.83333C4.16663 7.67428 5.65901 9.16667 7.49996 9.16667Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconAppWithBg = ({
  className,
  width = 20,
  height = 20,
  size,
  bgColor,
  color,
  onClick,
}: Props) => {
  const iconSize = size || width || 20;

  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        width: 40,
        height: 40,
        backgroundColor: bgColor,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <IconApp
        width={iconSize}
        height={iconSize}
        color={color}
      />
    </div>
  );
};

export const IconCheckmarkDocument = ({
  className,
  width = 20,
  height = 20,
  size,
  bgColor,
  color,
  onClick,
}: Props) => {
  const iconSize = size || width || 20;

  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        width: 40,
        height: 40,
        backgroundColor: bgColor,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6666 3.33337H3.33329C2.41282 3.33337 1.66663 4.07957 1.66663 5.00004V15C1.66663 15.9205 2.41282 16.6667 3.33329 16.6667H16.6666C17.5871 16.6667 18.3333 15.9205 18.3333 15V5.00004C18.3333 4.07957 17.5871 3.33337 16.6666 3.33337Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 10L9.16667 11.6667L12.5 8.33337"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconPeopleConnected = ({
  className,
  width = 20,
  height = 20,
  size,
  bgColor,
  color,
  onClick,
}: Props) => {
  const iconSize = size || width || 20;

  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        width: 40,
        height: 40,
        backgroundColor: bgColor,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3333 17.5V15.8333C13.3333 14.9493 12.9821 14.1014 12.357 13.4763C11.7319 12.8512 10.884 12.5 9.99996 12.5H4.99996C4.1159 12.5 3.26806 12.8512 2.64294 13.4763C2.01782 14.1014 1.66663 14.9493 1.66663 15.8333V17.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3334 2.60669C14.0482 2.792 14.6812 3.20941 15.1331 3.79341C15.585 4.37741 15.8302 5.09493 15.8302 5.83336C15.8302 6.57178 15.585 7.28931 15.1331 7.8733C14.6812 8.4573 14.0482 8.87471 13.3334 9.06002"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3334 17.5001V15.8334C18.3328 15.0948 18.087 14.3774 17.6345 13.7937C17.182 13.2099 16.5485 12.793 15.8334 12.6084"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49996 9.16667C9.34091 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34091 2.5 7.49996 2.5C5.65901 2.5 4.16663 3.99238 4.16663 5.83333C4.16663 7.67428 5.65901 9.16667 7.49996 9.16667Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconBuilding = ({
  className,
  width = 20,
  height = 20,
  size,
  bgColor,
  color,
  onClick,
}: Props) => {
  const iconSize = size || width || 20;

  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        width: 40,
        height: 40,
        backgroundColor: bgColor,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.33337 16.6667H16.6667M5.00004 16.6667V8.33337C5.00004 7.89135 5.17563 7.46742 5.48819 7.15486C5.80075 6.8423 6.22468 6.66671 6.66671 6.66671H13.3334C13.7754 6.66671 14.1993 6.8423 14.5119 7.15486C14.8244 7.46742 15 7.89135 15 8.33337V16.6667M5.00004 16.6667H15M8.33337 6.66671V3.33337C8.33337 2.89135 8.50896 2.46742 8.82152 2.15486C9.13408 1.8423 9.55801 1.66671 10 1.66671C10.442 1.66671 10.866 1.8423 11.1785 2.15486C11.4911 2.46742 11.6667 2.89135 11.6667 3.33337V6.66671M5.00004 11.6667H6.66671M5.00004 13.3334H6.66671M13.3334 11.6667H15M13.3334 13.3334H15"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconShield = ({
  className,
  width = 20,
  height = 20,
  size,
  bgColor,
  color,
  onClick,
}: Props) => {
  const iconSize = size || width || 20;

  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        width: 40,
        height: 40,
        backgroundColor: bgColor,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 1.66663L3.33337 4.16663V9.16663C3.33337 12.5 5.83337 15.5 10 18.3333C14.1667 15.5 16.6667 12.5 16.6667 9.16663V4.16663L10 1.66663Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 10L9.16667 11.6667L12.5 8.33337"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconSettings = ({
  className,
  width = 20,
  height = 20,
  size,
  bgColor,
  color,
  onClick,
}: Props) => {
  const iconSize = size || width || 20;

  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        width: 40,
        height: 40,
        backgroundColor: bgColor,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.25 10C16.25 10.2167 16.2583 10.425 16.2667 10.6417C16.275 10.8583 16.2833 11.0667 16.2833 11.2833C16.2833 11.5 16.275 11.7083 16.2667 11.925C16.2583 12.1417 16.25 12.35 16.25 12.5667C16.25 12.7833 16.2417 12.9917 16.2333 13.2083C16.225 13.425 16.2167 13.6333 16.2167 13.85L17.5 14.7083C17.6417 14.8083 17.6917 15 17.5917 15.1417L16.3917 16.875C16.2917 17.0167 16.1 17.0667 15.9583 16.9667L14.675 16.1083C14.4167 16.3167 14.15 16.5083 13.8833 16.6917C13.6167 16.875 13.3417 17.05 13.075 17.2167L12.8083 18.5833C12.7917 18.725 12.6583 18.8333 12.5167 18.8333H7.48333C7.34167 18.8333 7.20833 18.725 7.19167 18.5833L6.925 17.2167C6.65833 17.05 6.38333 16.875 6.11667 16.6917C5.85 16.5083 5.58333 16.3167 5.325 16.1083L4.04167 16.9667C3.9 17.0667 3.70833 17.0167 3.60833 16.875L2.40833 15.1417C2.30833 15 2.35833 14.8083 2.5 14.7083L3.78333 13.85C3.78333 13.6333 3.775 13.425 3.76667 13.2083C3.75833 12.9917 3.75 12.7833 3.75 12.5667C3.75 12.35 3.74167 12.1417 3.73333 11.925C3.725 11.7083 3.71667 11.5 3.71667 11.2833C3.71667 11.0667 3.725 10.8583 3.73333 10.6417C3.74167 10.425 3.75 10.2167 3.75 10C3.75 9.78333 3.74167 9.575 3.73333 9.35833C3.725 9.14167 3.71667 8.93333 3.71667 8.71667L2.5 7.85833C2.35833 7.75833 2.30833 7.56667 2.40833 7.425L3.60833 5.69167C3.70833 5.55 3.9 5.5 4.04167 5.6L5.325 6.45833C5.58333 6.25 5.85 6.05833 6.11667 5.875C6.38333 5.69167 6.65833 5.51667 6.925 5.35L7.19167 3.98333C7.20833 3.84167 7.34167 3.73333 7.48333 3.73333H12.5167C12.6583 3.73333 12.7917 3.84167 12.8083 3.98333L13.075 5.35C13.3417 5.51667 13.6167 5.69167 13.8833 5.875C14.15 6.05833 14.4167 6.25 14.675 6.45833L15.9583 5.6C16.1 5.5 16.2917 5.55 16.3917 5.69167L17.5917 7.425C17.6917 7.56667 17.6417 7.75833 17.5 7.85833L16.2167 8.71667C16.2167 8.93333 16.225 9.14167 16.2333 9.35833C16.2417 9.575 16.25 9.78333 16.25 10Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconGroup = ({
                            className,
                            width = 20,
                            height = 20,
                            size,
                            bgColor,
                            color,
                            onClick,
                          }: Props) => {
  const iconSize = size || width || 20;

  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        width: 40,
        height: 40,
        backgroundColor: bgColor,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3333 17.5V15.8333C13.3333 14.9493 12.9821 14.1014 12.357 13.4763C11.7319 12.8512 10.884 12.5 9.99996 12.5H4.99996C4.1159 12.5 3.26806 12.8512 2.64294 13.4763C2.01782 14.1014 1.66663 14.9493 1.66663 15.8333V17.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3334 2.60669C14.0482 2.792 14.6812 3.20941 15.1331 3.79341C15.585 4.37741 15.8302 5.09493 15.8302 5.83336C15.8302 6.57178 15.585 7.28931 15.1331 7.8733C14.6812 8.4573 14.0482 8.87471 13.3334 9.06002"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3334 17.5001V15.8334C18.3328 15.0948 18.087 14.3774 17.6345 13.7937C17.182 13.2099 16.5485 12.793 15.8334 12.6084"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49996 9.16667C9.34091 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34091 2.5 7.49996 2.5C5.65901 2.5 4.16663 3.99238 4.16663 5.83333C4.16663 7.67428 5.65901 9.16667 7.49996 9.16667Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const IconActivity = ({
                               className,
                               width,
                               height,
                               size,
                               filter,
                               color,
                               onClick,
                             }: Props) => (
  <img
    src={activityIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconActivityActive = ({
                                     className,
                                     width,
                                     height,
                                     size,
                                     filter,
                                     color,
                                     onClick,
                                   }: Props) => (
  <img
    src={activityActiveIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconSetting = ({
                              className,
                              width = 20,
                              height = 20,
                              size,
                              filter,
                              color = '#64748B',
                              onClick,
                            }: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M10 2.5L3.75 5.83333V10C3.75 13.75 6.25 17.0833 10 18.3333C13.75 17.0833 16.25 13.75 16.25 10V5.83333L10 2.5Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconSettingActive = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#FFFFFF',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#FFFFFF';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M10 2.5L3.75 5.83333V10C3.75 13.75 6.25 17.0833 10 18.3333C13.75 17.0833 16.25 13.75 16.25 10V5.83333L10 2.5Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconConfig = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#64748B',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 10C16.25 10.2167 16.2583 10.425 16.2667 10.6417C16.275 10.8583 16.2833 11.0667 16.2833 11.2833C16.2833 11.5 16.275 11.7083 16.2667 11.925C16.2583 12.1417 16.25 12.35 16.25 12.5667C16.25 12.7833 16.2417 12.9917 16.2333 13.2083C16.225 13.425 16.2167 13.6333 16.2167 13.85L17.5 14.7083C17.6417 14.8083 17.6917 15 17.5917 15.1417L16.3917 16.875C16.2917 17.0167 16.1 17.0667 15.9583 16.9667L14.675 16.1083C14.4167 16.3167 14.15 16.5083 13.8833 16.6917C13.6167 16.875 13.3417 17.05 13.075 17.2167L12.8083 18.5833C12.7917 18.725 12.6583 18.8333 12.5167 18.8333H7.48333C7.34167 18.8333 7.20833 18.725 7.19167 18.5833L6.925 17.2167C6.65833 17.05 6.38333 16.875 6.11667 16.6917C5.85 16.5083 5.58333 16.3167 5.325 16.1083L4.04167 16.9667C3.9 17.0667 3.70833 17.0167 3.60833 16.875L2.40833 15.1417C2.30833 15 2.35833 14.8083 2.5 14.7083L3.78333 13.85C3.78333 13.6333 3.775 13.425 3.76667 13.2083C3.75833 12.9917 3.75 12.7833 3.75 12.5667C3.75 12.35 3.74167 12.1417 3.73333 11.925C3.725 11.7083 3.71667 11.5 3.71667 11.2833C3.71667 11.0667 3.725 10.8583 3.73333 10.6417C3.74167 10.425 3.75 10.2167 3.75 10C3.75 9.78333 3.74167 9.575 3.73333 9.35833C3.725 9.14167 3.71667 8.93333 3.71667 8.71667L2.5 7.85833C2.35833 7.75833 2.30833 7.56667 2.40833 7.425L3.60833 5.69167C3.70833 5.55 3.9 5.5 4.04167 5.6L5.325 6.45833C5.58333 6.25 5.85 6.05833 6.11667 5.875C6.38333 5.69167 6.65833 5.51667 6.925 5.35L7.19167 3.98333C7.20833 3.84167 7.34167 3.73333 7.48333 3.73333H12.5167C12.6583 3.73333 12.7917 3.84167 12.8083 3.98333L13.075 5.35C13.3417 5.51667 13.6167 5.69167 13.8833 5.875C14.15 6.05833 14.4167 6.25 14.675 6.45833L15.9583 5.6C16.1 5.5 16.2917 5.55 16.3917 5.69167L17.5917 7.425C17.6917 7.56667 17.6417 7.75833 17.5 7.85833L16.2167 8.71667C16.2167 8.93333 16.225 9.14167 16.2333 9.35833C16.2417 9.575 16.25 9.78333 16.25 10Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconConfigActive = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#FFFFFF',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#FFFFFF';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 10C16.25 10.2167 16.2583 10.425 16.2667 10.6417C16.275 10.8583 16.2833 11.0667 16.2833 11.2833C16.2833 11.5 16.275 11.7083 16.2667 11.925C16.2583 12.1417 16.25 12.35 16.25 12.5667C16.25 12.7833 16.2417 12.9917 16.2333 13.2083C16.225 13.425 16.2167 13.6333 16.2167 13.85L17.5 14.7083C17.6417 14.8083 17.6917 15 17.5917 15.1417L16.3917 16.875C16.2917 17.0167 16.1 17.0667 15.9583 16.9667L14.675 16.1083C14.4167 16.3167 14.15 16.5083 13.8833 16.6917C13.6167 16.875 13.3417 17.05 13.075 17.2167L12.8083 18.5833C12.7917 18.725 12.6583 18.8333 12.5167 18.8333H7.48333C7.34167 18.8333 7.20833 18.725 7.19167 18.5833L6.925 17.2167C6.65833 17.05 6.38333 16.875 6.11667 16.6917C5.85 16.5083 5.58333 16.3167 5.325 16.1083L4.04167 16.9667C3.9 17.0667 3.70833 17.0167 3.60833 16.875L2.40833 15.1417C2.30833 15 2.35833 14.8083 2.5 14.7083L3.78333 13.85C3.78333 13.6333 3.775 13.425 3.76667 13.2083C3.75833 12.9917 3.75 12.7833 3.75 12.5667C3.75 12.35 3.74167 12.1417 3.73333 11.925C3.725 11.7083 3.71667 11.5 3.71667 11.2833C3.71667 11.0667 3.725 10.8583 3.73333 10.6417C3.74167 10.425 3.75 10.2167 3.75 10C3.75 9.78333 3.74167 9.575 3.73333 9.35833C3.725 9.14167 3.71667 8.93333 3.71667 8.71667L2.5 7.85833C2.35833 7.75833 2.30833 7.56667 2.40833 7.425L3.60833 5.69167C3.70833 5.55 3.9 5.5 4.04167 5.6L5.325 6.45833C5.58333 6.25 5.85 6.05833 6.11667 5.875C6.38333 5.69167 6.65833 5.51667 6.925 5.35L7.19167 3.98333C7.20833 3.84167 7.34167 3.73333 7.48333 3.73333H12.5167C12.6583 3.73333 12.7917 3.84167 12.8083 3.98333L13.075 5.35C13.3417 5.51667 13.6167 5.69167 13.8833 5.875C14.15 6.05833 14.4167 6.25 14.675 6.45833L15.9583 5.6C16.1 5.5 16.2917 5.55 16.3917 5.69167L17.5917 7.425C17.6917 7.56667 17.6417 7.75833 17.5 7.85833L16.2167 8.71667C16.2167 8.93333 16.225 9.14167 16.2333 9.35833C16.2417 9.575 16.25 9.78333 16.25 10Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconArrowUpActive = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={arrowUpActiveIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconArrowRightActive = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={arrowRightActiveIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconArrowPageLeft = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={arrowPageLeftIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconArrowPageRight = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={arrowPageRightIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconCaretDown = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={caretDownIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconDot = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props): JSX.Element => {
  return (
    <svg
      width={width ?? 6}
      height={height ?? 7}
      viewBox={`0 0 ${width ?? 6} ${height ?? 7}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="3"
        cy="3.5"
        r="3"
        fill={color ?? '#ED7632'}
      />
    </svg>
  );
};

export const IconWelcome = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={welcomeIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconArrowDown = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={arrowDownIcon}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconArrowRight = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#64748B',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M13.5961 6.71875L16.8773 10L13.5961 13.2812"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.125 10H16.875"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V3.75C3.125 3.58424 3.19085 3.42527 3.30806 3.30806C3.42527 3.19085 3.58424 3.125 3.75 3.125H9.375"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};


export const IconTicket = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#64748B',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M16.875 10C16.875 10.2167 16.8667 10.425 16.8583 10.6417C16.85 10.8583 16.8417 11.0667 16.8333 11.2833C16.825 11.5 16.8167 11.7083 16.8083 11.925C16.8 12.1417 16.7917 12.35 16.7917 12.5667C16.7917 12.7833 16.7833 12.9917 16.775 13.2083C16.7667 13.425 16.7583 13.6333 16.7583 13.85L15.475 14.7083C15.3333 14.8083 15.2833 15 15.3833 15.1417L16.5833 16.875C16.6833 17.0167 16.875 17.0667 17.0167 16.9667L18.3 16.1083C18.5583 16.3167 18.825 16.5083 19.0917 16.6917C19.3583 16.875 19.6333 17.05 19.9 17.2167L20.1667 18.5833C20.1833 18.725 20.3167 18.8333 20.4583 18.8333H15.425C15.2833 18.8333 15.15 18.725 15.1333 18.5833L14.8667 17.2167C14.6 17.05 14.325 16.875 14.0583 16.6917C13.7917 16.5083 13.525 16.3167 13.2667 16.1083L11.9833 16.9667C11.8417 17.0667 11.65 17.0167 11.55 16.875L10.35 15.1417C10.25 15 10.3 14.8083 10.4417 14.7083L11.725 13.85C11.725 13.6333 11.7167 13.425 11.7083 13.2083C11.7 12.9917 11.6917 12.7833 11.6917 12.5667C11.6917 12.35 11.6833 12.1417 11.675 11.925C11.6667 11.7083 11.6583 11.5 11.65 11.2833C11.6417 11.0667 11.6333 10.8583 11.625 10.6417C11.6167 10.425 11.6083 10.2167 11.6083 10C11.6083 9.78333 11.6167 9.575 11.625 9.35833C11.6333 9.14167 11.6417 8.93333 11.65 8.71667L10.4417 7.85833C10.3 7.75833 10.25 7.56667 10.35 7.425L11.55 5.69167C11.65 5.55 11.8417 5.5 11.9833 5.6L13.2667 6.45833C13.525 6.25 13.7917 6.05833 14.0583 5.875C14.325 5.69167 14.6 5.51667 14.8667 5.35L15.1333 3.98333C15.15 3.84167 15.2833 3.73333 15.425 3.73333H20.4583C20.6 3.73333 20.7333 3.84167 20.75 3.98333L21.0167 5.35C21.2833 5.51667 21.5583 5.69167 21.825 5.875C22.0917 6.05833 22.3583 6.25 22.6167 6.45833L23.9 5.6C24.0417 5.5 24.2333 5.55 24.3333 5.69167L25.5333 7.425C25.6333 7.56667 25.5833 7.75833 25.4417 7.85833L24.1583 8.71667C24.1583 8.93333 24.1667 9.14167 24.175 9.35833C24.1833 9.575 24.1917 9.78333 24.1917 10C24.1917 10.2167 24.2 10.425 24.2083 10.6417C24.2167 10.8583 24.225 11.0667 24.2333 11.2833C24.2417 11.5 24.25 11.7083 24.2583 11.925C24.2667 12.1417 24.275 12.35 24.275 12.5667C24.275 12.7833 24.2833 12.9917 24.2917 13.2083C24.3 13.425 24.3083 13.6333 24.3083 13.85"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 1.66663V5.83329"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 18.3334V14.1667"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58337 14.1666L7.50004 16.25L10.4167 14.1666"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58337 5.83337L7.50004 3.75L10.4167 5.83337"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconTicketActive = ({
  className,
  width = 20,
  height = 20,
  size,
  filter,
  color = '#FFFFFF',
  onClick,
}: Props) => {
  const iconWidth = width || size || 20;
  const iconHeight = height || size || 20;
  const strokeColor = color || '#FFFFFF';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M16.875 10C16.875 10.2167 16.8667 10.425 16.8583 10.6417C16.85 10.8583 16.8417 11.0667 16.8333 11.2833C16.825 11.5 16.8167 11.7083 16.8083 11.925C16.8 12.1417 16.7917 12.35 16.7917 12.5667C16.7917 12.7833 16.7833 12.9917 16.775 13.2083C16.7667 13.425 16.7583 13.6333 16.7583 13.85L15.475 14.7083C15.3333 14.8083 15.2833 15 15.3833 15.1417L16.5833 16.875C16.6833 17.0167 16.875 17.0667 17.0167 16.9667L18.3 16.1083C18.5583 16.3167 18.825 16.5083 19.0917 16.6917C19.3583 16.875 19.6333 17.05 19.9 17.2167L20.1667 18.5833C20.1833 18.725 20.3167 18.8333 20.4583 18.8333H15.425C15.2833 18.8333 15.15 18.725 15.1333 18.5833L14.8667 17.2167C14.6 17.05 14.325 16.875 14.0583 16.6917C13.7917 16.5083 13.525 16.3167 13.2667 16.1083L11.9833 16.9667C11.8417 17.0667 11.65 17.0167 11.55 16.875L10.35 15.1417C10.25 15 10.3 14.8083 10.4417 14.7083L11.725 13.85C11.725 13.6333 11.7167 13.425 11.7083 13.2083C11.7 12.9917 11.6917 12.7833 11.6917 12.5667C11.6917 12.35 11.6833 12.1417 11.675 11.925C11.6667 11.7083 11.6583 11.5 11.65 11.2833C11.6417 11.0667 11.6333 10.8583 11.625 10.6417C11.6167 10.425 11.6083 10.2167 11.6083 10C11.6083 9.78333 11.6167 9.575 11.625 9.35833C11.6333 9.14167 11.6417 8.93333 11.65 8.71667L10.4417 7.85833C10.3 7.75833 10.25 7.56667 10.35 7.425L11.55 5.69167C11.65 5.55 11.8417 5.5 11.9833 5.6L13.2667 6.45833C13.525 6.25 13.7917 6.05833 14.0583 5.875C14.325 5.69167 14.6 5.51667 14.8667 5.35L15.1333 3.98333C15.15 3.84167 15.2833 3.73333 15.425 3.73333H20.4583C20.6 3.73333 20.7333 3.84167 20.75 3.98333L21.0167 5.35C21.2833 5.51667 21.5583 5.69167 21.825 5.875C22.0917 6.05833 22.3583 6.25 22.6167 6.45833L23.9 5.6C24.0417 5.5 24.2333 5.55 24.3333 5.69167L25.5333 7.425C25.6333 7.56667 25.5833 7.75833 25.4417 7.85833L24.1583 8.71667C24.1583 8.93333 24.1667 9.14167 24.175 9.35833C24.1833 9.575 24.1917 9.78333 24.1917 10C24.1917 10.2167 24.2 10.425 24.2083 10.6417C24.2167 10.8583 24.225 11.0667 24.2333 11.2833C24.2417 11.5 24.25 11.7083 24.2583 11.925C24.2667 12.1417 24.275 12.35 24.275 12.5667C24.275 12.7833 24.2833 12.9917 24.2917 13.2083C24.3 13.425 24.3083 13.6333 24.3083 13.85"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 1.66663V5.83329"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 18.3334V14.1667"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58337 14.1666L7.50004 16.25L10.4167 14.1666"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58337 5.83337L7.50004 3.75L10.4167 5.83337"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconKey = ({
  className,
  width = 24,
  height = 24,
  size,
  filter,
  color = '#64748B',
  onClick,
}: Props) => {
  const iconWidth = width || size || 24;
  const iconHeight = height || size || 24;
  const strokeColor = color || '#64748B';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M15.5 7.5L18.5 10.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.5L17.5 5.5C18.3284 4.67157 19.6716 4.67157 20.5 5.5C21.3284 6.32843 21.3284 7.67157 20.5 8.5L19.5 9.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1213 11.8787C13.2929 13.0503 13.2929 14.9497 12.1213 16.1213C10.9497 17.2929 9.05025 17.2929 7.87868 16.1213C6.70711 14.9497 6.70711 13.0503 7.87868 11.8787C9.05025 10.7071 10.9497 10.7071 12.1213 11.8787Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 11.5L19 5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconKeyActive = ({
  className,
  width = 24,
  height = 24,
  size,
  filter,
  color = '#FFFFFF',
  onClick,
}: Props) => {
  const iconWidth = width || size || 24;
  const iconHeight = height || size || 24;
  const strokeColor = color || '#FFFFFF';

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick as any}
      style={{ filter }}
    >
      <path
        d="M15.5 7.5L18.5 10.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.5L17.5 5.5C18.3284 4.67157 19.6716 4.67157 20.5 5.5C21.3284 6.32843 21.3284 7.67157 20.5 8.5L19.5 9.5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1213 11.8787C13.2929 13.0503 13.2929 14.9497 12.1213 16.1213C10.9497 17.2929 9.05025 17.2929 7.87868 16.1213C6.70711 14.9497 6.70711 13.0503 7.87868 11.8787C9.05025 10.7071 10.9497 10.7071 12.1213 11.8787Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 11.5L19 5"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconFirstLine = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <svg
    width={width ?? 80}
    height={height ?? 38}
    viewBox={`0 0 ${width ?? 80} ${height ?? 38}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="79"
      height="37"
      rx="7.5"
      fill="#F5F4F3"
    />
    <rect
      x="0.5"
      y="0.5"
      width="79"
      height="37"
      rx="7.5"
      stroke="#DDE4F2"
    />
    <path
      d="M29.5003 13.375H23.667C23.3253 13.375 23.042 13.0917 23.042 12.75C23.042 12.4083 23.3253 12.125 23.667 12.125H29.5003C29.842 12.125 30.1253 12.4083 30.1253 12.75C30.1253 13.0917 29.842 13.375 29.5003 13.375Z"
      fill="#011233"
    />
    <path
      d="M29.5003 17.0415H23.667C23.6368 17.0415 23.6056 17.0292 23.5799 17.0036C23.5543 16.9779 23.542 16.9467 23.542 16.9165C23.542 16.8864 23.5543 16.8551 23.5799 16.8294C23.6056 16.8038 23.6368 16.7915 23.667 16.7915H29.5003C29.5305 16.7915 29.5618 16.8038 29.5874 16.8294C29.613 16.8551 29.6253 16.8864 29.6253 16.9165C29.6253 16.9467 29.613 16.9779 29.5874 17.0036C29.5618 17.0292 29.5305 17.0415 29.5003 17.0415Z"
      fill="#011233"
      stroke="#011233"
    />
    <path
      d="M29.5 21.7085H14.5C14.1583 21.7085 13.875 21.4252 13.875 21.0835C13.875 20.7418 14.1583 20.4585 14.5 20.4585H29.5C29.8417 20.4585 30.125 20.7418 30.125 21.0835C30.125 21.4252 29.8417 21.7085 29.5 21.7085Z"
      fill="#011233"
    />
    <path
      d="M29.5 25.875H14.5C14.1583 25.875 13.875 25.5917 13.875 25.25C13.875 24.9083 14.1583 24.625 14.5 24.625H29.5C29.8417 24.625 30.125 24.9083 30.125 25.25C30.125 25.5917 29.8417 25.875 29.5 25.875Z"
      fill="#011233"
    />
    <path
      d="M18.6 11.9165H16.2333C15.0667 11.9165 14.5 12.4832 14.5 13.6498V16.0248C14.5 17.1915 15.0667 17.7582 16.2333 17.7582H18.6083C19.775 17.7582 20.3417 17.1915 20.3417 16.0248V13.6498C20.3333 12.4832 19.7667 11.9165 18.6 11.9165Z"
      fill="#011233"
    />
    <line
      x1="40.5"
      y1="10"
      x2="40.5"
      y2="28"
      stroke="#8EA2C8"
    />
    <path
      d="M54.892 27.9582H51.5253C49.8503 27.9582 49.042 27.1832 49.042 25.5832V12.4165C49.042 10.8165 49.8587 10.0415 51.5253 10.0415H54.892C56.567 10.0415 57.3753 10.8165 57.3753 12.4165V25.5832C57.3753 27.1832 56.5587 27.9582 54.892 27.9582ZM51.5253 11.2915C50.467 11.2915 50.292 11.5748 50.292 12.4165V25.5832C50.292 26.4248 50.467 26.7082 51.5253 26.7082H54.892C55.9503 26.7082 56.1253 26.4248 56.1253 25.5832V12.4165C56.1253 11.5748 55.9503 11.2915 54.892 11.2915H51.5253Z"
      fill="#8EA2C8"
    />
    <path
      d="M64.475 21.6248H61.1083C60.3384 21.6248 59.8662 21.446 59.5842 21.1761C59.3066 20.9104 59.125 20.4714 59.125 19.7498V12.4165C59.125 11.6963 59.308 11.2569 59.5869 10.9907C59.8704 10.7201 60.3432 10.5415 61.1083 10.5415H64.475C65.2449 10.5415 65.7171 10.7204 65.9991 10.9902C66.2768 11.256 66.4583 11.6949 66.4583 12.4165V19.7498C66.4583 20.4701 66.2754 20.9094 65.9964 21.1757C65.713 21.4462 65.2401 21.6248 64.475 21.6248ZM61.1083 10.7915C60.5806 10.7915 60.0756 10.8504 59.7412 11.1848C59.4031 11.523 59.375 12.0094 59.375 12.4165V19.7498C59.375 20.1569 59.4031 20.6434 59.7412 20.9815C60.0756 21.3159 60.5806 21.3748 61.1083 21.3748H64.475C65.0027 21.3748 65.5077 21.3159 65.8421 20.9815C66.1802 20.6434 66.2083 20.1569 66.2083 19.7498V12.4165C66.2083 12.0094 66.1802 11.523 65.8421 11.1848C65.5077 10.8504 65.0027 10.7915 64.475 10.7915H61.1083Z"
      fill="#8EA2C8"
      stroke="#8EA2C8"
    />
  </svg>
);

export const IconDragable = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <svg
    width="8"
    height="16"
    viewBox="0 0 8 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="3" height="3" fill="#D9D9D9" />
    <rect y="6.5" width="3" height="3" fill="#D9D9D9" />
    <rect y="12.5" width="3" height="3" fill="#D9D9D9" />
    <rect
      x="5"
      y="0.5"
      width="3"
      height="3"
      fill="#D9D9D9"
    />
    <rect
      x="5"
      y="6.5"
      width="3"
      height="3"
      fill="#D9D9D9"
    />
    <rect
      x="5"
      y="12.5"
      width="3"
      height="3"
      fill="#D9D9D9"
    />
  </svg>
);
